import { render, staticRenderFns } from "./InboxButton.vue?vue&type=template&id=68e5722f"
import script from "./InboxButton.vue?vue&type=script&lang=js"
export * from "./InboxButton.vue?vue&type=script&lang=js"
import style0 from "./InboxButton.vue?vue&type=style&index=0&id=68e5722f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports